/**
 * @generated SignedSource<<14414b3584bfb857ee82ce72ee54f28d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type createStandaloneSiteDialogCheckDomainQuery$variables = {
  domain: string;
};
export type createStandaloneSiteDialogCheckDomainQuery$data = {
  readonly checkStandaloneSiteDomain: {
    readonly isAvailable: boolean;
    readonly message: string | null;
  };
};
export type createStandaloneSiteDialogCheckDomainQuery = {
  response: createStandaloneSiteDialogCheckDomainQuery$data;
  variables: createStandaloneSiteDialogCheckDomainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "domain"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "domain",
        "variableName": "domain"
      }
    ],
    "concreteType": "StandaloneSiteDomainCheck",
    "kind": "LinkedField",
    "name": "checkStandaloneSiteDomain",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAvailable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createStandaloneSiteDialogCheckDomainQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "createStandaloneSiteDialogCheckDomainQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "31c69d1c0dac40969578d30e6828ee70",
    "id": null,
    "metadata": {},
    "name": "createStandaloneSiteDialogCheckDomainQuery",
    "operationKind": "query",
    "text": "query createStandaloneSiteDialogCheckDomainQuery(\n  $domain: String!\n) {\n  checkStandaloneSiteDomain(domain: $domain) {\n    isAvailable\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "0fe1f2b0020ead90f07a53438d40ae9d";

export default node;
